<template>
  <div
    v-wechat-title="$route.meta.title"
    class="indexPage"
  >
    <div class="fixed_top">
      <div class="search-bar">
        <img class="goback" @click="$router.go(-1)" src="../assets/pingzi/back.png" alt="" />
        <div
          class="select-warehouse"
        >
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="warehouse_val"
              :options="IndexState.warehouseList"
              @change="changeWalehouse"
            />
          </van-dropdown-menu>
        </div>
        <van-search
          v-model="searchValue"
          placeholder="请输入产品名称,型号,品牌,分类检索"
          @search="onSearch"
          @clear="onClear"
        >
        </van-search>
        <div class="scan" @click="toMiniScan" v-if="isScanCode==1"><img src="../assets/icon/saoyisao2.png" alt=""></div>
      </div>
      <sort-bar
        :service="{ ...IndexState }"
        @sort="onSort"
      />
      <div class="van-hairline--bottom"></div>
    </div>
    <div style="height:90px"></div>
    <div class="tabsCon">
      <div v-show="tabActive==1">
        <div class="container">

          <!-- 列表 -->
          <van-list
            :finished="finished"
            finished-text
            v-model="loading"
            @load="onLoad"
          >
            <ul class="list list2">
              <buy-car-item
                v-for="(item, index) of list"
                :index="index"
                :item="item"
                :key="index"
                :lv="1"
                :wareHouseType="IndexStore.state.wareHouseType"
                :enableCheck="true"
                :isAddCart="false"
                @handleSelect="handleSelect.apply(this, $event)"
                @handleJian="handleJian.apply(this, $event)"
                @inputFocus="inputFocus.apply(this, $event)"
                @handleAdd="handleAdd.apply(this, $event)"
                @handleShow="handleShow.apply(this, $event)"
                @handleAddCart="handleAddCart.apply(this, $event)"
              ></buy-car-item>
            </ul>
          </van-list>
        </div>
        <!-- 购物车空状态 -->
        <div
          ref="buyBlock"
          class="buyBlock"
          v-if="buyBlockShow"
        >
          <div class="buyBlockTop">
            <img src="../assets/icon/gouwuche.png" />
            <span class="buyBlockTxt">没有找到匹配数据</span>
          </div>
        </div>

        <van-goods-action>
          <van-goods-action-icon
            icon="cart-o"
            text="购物车"
            :badge="buyCarNum"
            :class="{ bounceIn: bounceIn }"
            @click="toBuyCar"
          />

          <van-goods-action-button
            color="#4FAE54"
            type="warning"
            @click="addBuyCar"
            text="加入购物车"
          />
        </van-goods-action>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { List, Toast } from "vant";
import util from "../utils/util";
import basedata from "../utils/basedata";
import api from "../services/api";
import car from "../services/car";
import feach from "../utils/axiosp";
import { connect } from "tls";
import { buildImgSrc } from "../services/buyCar";
import buyCarItem from "../components/buyCarItem.vue";
import vinMoreInfo from "../components/vinMoreInfo.vue";
import brandsFilter from "../components/brandsFilter.vue";
import sortBar from "../components/sortBar.vue";
import iconBar from "../components/iconBar.vue";
import buyCarStore from "../store/buycar";
import IndexStore from "../store/Index";
import FirmOrderStore from "../store/FirmOrder";
import SimpleTable from "../components/table/SimpleTable";
import SimpleTableGroupList from "../components/list/SimpleTableGroupList";
import activityList from "../components/activityList";

import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Col,
  Row,
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Index from "../store/Index";

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Search);

export default {
  name: "goodsSearch",
  components: {
    buyCarItem,
    vinMoreInfo,
    brandsFilter,
    sortBar,
    SimpleTable,
    SimpleTableGroupList,
    iconBar,
    activityList,
  },
  computed: {
    //仓库下拉框选中值
    warehouse_val: {
      set: (val) => {
        IndexStore.state.warehouse_val = val;
      },
      get: () => {
        return IndexStore.state.warehouse_val;
      },
    },
    //仓库下拉框选中文本
    warehouseText: () => IndexStore.state.warehouseText,
    list: () => IndexStore.state.list.filter((it) => it.isShow),

    CompanyName: () => IndexStore.state.CompanyName,
    EmployeeName: () => IndexStore.state.EmployeeName,
    EmployeePhone: () => IndexStore.state.EmployeePhone,

    buyBlockShow() {
      return !this.loading && this.list.length === 0;
    },
    buyBlockShow2() {
      return !this.loading && this.list2.length === 0;
    },
    //输出所有选择的数据  唯一 （互换产品数量叠加）
    finalList() {
      var finalDict = {};
      var finalList = [];
      let calcFinalList = (it) => {
        if (it.check) {
          if (finalDict[it.ProductId] === undefined) {
            finalDict[it.ProductId] = Object.assign({}, it);
            finalList.push(finalDict[it.ProductId]);
          } else {
            finalDict[it.ProductId].num += it.num;
          }
        }
      };
      this.list.forEach((it) => {
        calcFinalList(it);
        //互换商品
        it.list.forEach(calcFinalList);
      });
      return finalList;
    },
    buyCarNum() {
      let sum = 0;
      this.buyCarState.list.forEach((it) => {
        sum += it.num;
      });

      return sum;
    },
  },
  data() {
    return {
      FirmOrderStore,
      IndexStore,
      buyCarObj: buyCarStore,
      buyCarState: buyCarStore.state,
      IndexState: IndexStore.state,
      active: 0,

      isShowMoreMenu: false,
      searchValue: "",
      list2Active: "list",

      queryData: {
        QueryProductEnum: 1,
        ProductName: "",
        pageSize: 10,
        pageNo: 0,
        RobotCode:''
      },
      list2: [],
      imgUrl: util.getStoObj("maindomain"),
      selectIndex: 0,
      // 产品id
      productId: null,
      // 产品数量
      productNum: 0,
      // 总价
      finalAmount: 0,
      // 短缺
      ConditionsOfSatisfaction: null,
      dc: null,
      loading: false,
      finished: false,

      xiugaiShow: false,
      StoreNum: 0,
      changeNum: 0,
      bounceIn: false,
      warehouseInitFinished: false,
      listUrl: "index",
      isType: 1,
      employeeName: "", //员工姓名
      employeePhone: "", //员工手机号
      customerName: "", //客户名称
      tabActive: 1,
      searchList: [],
      warehouseListData:[],
      isScanCode:0
    };
  },
  async created() {
    IndexStore.state.list = [];
    // if(util.getStoObj("urlQuery")){
    //   let urlQuery = util.getStoObj("urlQuery");
    //   this.queryData.BrandId = urlQuery.BrandId;
    //   this.queryData.ProductClassifyId = urlQuery.ProductClassifyId;
    //   this.queryData.VehicleTypeId = urlQuery.VehicleTypeId;
    //   this.queryData.RobotCode = urlQuery.RobotCode;
    //   this.queryData.Vin = urlQuery.Vin;
    //   this.queryData.Model = urlQuery.carTypeName;
    //   this.queryData.Keyword = urlQuery.Keyword;
    // }
    if (util.getStoObj("allinfo")) {
      this.employeeName = util.getStoObj("allinfo").UserName;
      this.employeePhone = util.getStoObj("allinfo").LegalPersonPhone;
    }
    let res = await api.GetProductSettingList();
    if (res.ResultType == 1) {
      localStorage.setItem("productSetting", JSON.stringify(res.Data.filter((item) => item.IsSelect == 1)));
    }
    // let initData = []
    // IndexStore.initList(initData);
    // this.IndexState.MallActivityManagementlist = [];
    // IndexStore.state.list = [];
  },
  async mounted() {
    this.$parent.Loading(false);
    this.isType = util.getStoObj("urlQuery").IsTypr;
    this.queryData.RobotCode = util.getStoObj("urlQuery").RobotCode
    if (this.isType == 1) {
      this.customerName = sessionStorage.getItem("CustomerName");
    }
    this.loading = true;
    this.onLoad();
  },
  methods: {
    toErrorCorrection(data) {
      console.log(this.IndexState.VehicleTypeId);
      console.log(data);
      this.$router.push({
        path: "/errorCorrection",
        query: {
          ProductTitle: data.ProductTitle, //产品名称
          ProductBrandName: data.ProductBrandName, //品牌名称
          ManuProductCode: data.ManuProductCode, //产品型号
          VehicleTypeId: this.IndexState.VehicleTypeId, //车型ID
          vinCode: this.IndexState.Vin, //vin码
          ProductId: data.ProductId, //产品ID
          BrandId: data.ProductBrandId, //品牌ID
        },
      });
    },
    toMiniScan(){
      wx.miniProgram.navigateTo({
        url: `../index/wareHouseOut/index?warehouseId=${this.warehouse_val}&CompanyName=${IndexStore.state.CompanyName}&VehicleTypeId=${IndexStore.state.VehicleTypeId}`,
      });
    },
    onMoreClick() {
      this.isShowMoreMenu = !this.isShowMoreMenu;
    },
    toBuyCar() {
      this.$router.push(`/buyCar`);
    },

    //onSearch: (keyword) => IndexStore.setKeyword(keyword).search(),
    onSearch() {
      IndexStore.state.list = [];
      this.finished = false;
      this.queryData.pageNo = 0;
      this.searchList = [];
      this.queryData.ProductName = this.searchValue;
      this.gteList(this.queryData);
    },
    onClear() {
      IndexStore.setKeyword("").search();
    },
    onFilterSearch: ({ brands, categorys }) => {
      IndexStore.setBrandList(brands)
        .setClassList(categorys)
        .search();
    },

    onSort: (sortItem, orderBy) => IndexStore.sort(sortItem, orderBy),

    addBuyCar() {
      if (!this.checkSelected()) {
        return;
      }
      this.finalList.forEach((it) => {
        it.WarehouseId = this.warehouse_val;
      });
      buyCarStore.batchAdd(this.finalList);
      console.log(buyCarStore);
      this.bounceIn = true;
      setTimeout(() => (this.bounceIn = false), 500);
      this.list.forEach((it) => (it.check = false));
      Toast("添加成功");
    },
    //立即结算
    firmOrder() {
      if (!this.checkSelected()) {
        return;
      }

      FirmOrderStore.setForm("index");

      this.finalList.forEach((it) => {
        it.WarehouseId = this.warehouse_val;
      });

      FirmOrderStore.updateList(this.finalList);

      this.$router.push(`/firmOrder`);
    },
    //检查选择的商品
    checkSelected() {
      if (this.finalList.length === 0) {
        Toast("请选择产品");
        return false;
      }
      if (this.finalList.some((it) => it.Price === 0)) {
        Toast("零元商品暂不可购买");
        return false;
      }

      return true;
    },

    changeNumber(e) {
      console.log(e.target.value);
      let number = e.target.value;
      if (number < 0) return (this.changeNum = 1);
    },
    inputFocus(item) {
      this.changeNum = item.num;
      this.xiugaiShow = true;
      this.selectItem = item;
      this.StoreNum = item.StoreNum;
    },
    priceChange(e) {
      this.xiugaiShow = !this.xiugaiShow;
    },
    priceChangePost(selectItem, num) {
      if (util.checkBuyIpt(num)) {
        this.selectItem.num = parseInt(num);
        this.xiugaiShow = false;
        this.goodsNum();
        this.goodsTotal();
      } else {
        util.toast("输入有误");
      }
    },
    // 获取列表
    gteList(data) {
      this.loading = true;
      let getListFunc = api.getProductSearch;
      return getListFunc(data)
        .then((res) => {
          if (res.ResultType === 1) {
            res.Data = res.Data || [];
            if (res.Data.length > 0) {
              let preBuildData = (it) => {
                it.Price = it.Price || 0;
                it.num = 1;
                it.check = false;
                it.showList = false; //默认不显示互换
                it = buildImgSrc(it);
                return it;
              };
              res.Data = res.Data.map((it) => {
                it = preBuildData(it);
                it.ProductName = it.ProductName || it.Text;
                it.IsFilter = 1;
                it.isShow = it.IsFilter ? true : false;
                it.list = it.TyingProductInfo || [];
                it.list = it.list.map(preBuildData);
                //it.Price = 100;
                return it;
              }).map(buildImgSrc);
              res.Data.forEach((item) => {
                this.searchList.push(item);
              });
              IndexStore.initList(this.searchList);
              this.queryData.pageNo++;
            } else {
              this.finished = true;
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = true;
            Toast(res.Reason || "系统繁忙，请您稍后再试。");
          }
        })
        .catch((err) => {
          Toast(err || "系统繁忙，请您稍后再试。");
          console.error(err);
          this.loading = false;
          this.finished = true;
        });
    },
    // 单个加入购物车
    handleAddCart(data, index) {
      let list = [];
      list.push(data);
      buyCarStore.batchAdd(list);
    },
    // 选择产品
    handleSelect(data, index) {
      data.check = !data.check;
      this.goodsTotal();
      this.goodsNum();
    },
    // 添加
    handleAdd(index, data) {
      let list = this.list;
      data.num += 1;
      this.goodsTotal();
      this.goodsNum();
    },
    // 减去
    handleJian(index, data) {
      let list = this.list;
      let num = data.num;
      if (num === 1) return;
      data.num -= 1;
      this.goodsTotal();
      this.goodsNum();
    },
    // 显示互换产品
    handleShow(data) {
      data.showList = true;
    },
    // 合计价格
    goodsTotal() {
      let list = this.finalList;
      let num = 0;
      let total = 0;
      list.filter((item) => item.check).map((it) => {
        num += it.Price * it.num;
      });
      this.finalAmount = num;
    },
    // 商品件数
    goodsNum(type) {
      let num = 0;
      let list = this.finalList;
      list.map((item) => {
        if (item.check) {
          num += item.num;
        }
      });
      this.productNum = num;
    },
    // 滚动加载
    async onLoad() {
      if (!this.warehouseInitFinished) {
        await this.warehouseInit();
        this.warehouseInitFinished = true;
      }
      console.log('warehouse_val',this.warehouse_val);
      this.queryData.WarehouseId = this.warehouse_val||0;
      this.queryData.QueryProductEnum = 1;
      await this.gteList(this.queryData);
    },
    //切换仓库
    async changeWalehouse() {
      const loading = Toast.loading({ message: "加载中...", duration: 0 });
      this.queryData.WarehouseId = this.warehouse_val;
      this.warehouseListData.forEach((item)=>{
        if(parseInt(this.warehouse_val)==parseInt(item.Value)){
          this.isScanCode = item.ValueTwo
        }
      })
      this.queryData.QueryProductEnum = 1;
      this.queryData.pageNo = 0;
      this.searchList = [];
      await this.gteList(this.queryData);
      loading.clear();
    },
    //仓库列表初始化
    async warehouseInit() {
      let wareData = await api.isWarehouseNew();
      IndexStore.state.wareHouseType = parseInt(wareData.Data.DefaultWarehouse);
      let _warehouseList = [];
      this.warehouseListData = wareData.Data.WarehouseList;
      this.warehouseListData.forEach((item) => {
        _warehouseList.push({
          value: parseInt(item.Value),
          text: item.Text,
        });
        if (item.Selected) {
          this.warehouse_val = parseInt(item.Value);
          IndexStore.state.warehouseText = item.Text;
          this.isScanCode = item.ValueTwo
        } else {
          this.warehouse_val = parseInt(this.warehouseListData[0].Value);
          IndexStore.state.warehouseText = this.warehouseListData[0].Text;
        }
      });
      this.IndexState.warehouseList = _warehouseList;
      this.IndexState.MallActivityManagementlist = wareData.Data.MallActivityManagementlist;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/activityBills.scss";
.container {
  background: #fff;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 5px;
}
.fixed_top {
  position: fixed;
  width: 100%;
  z-index: 10;
  background: #fff;
}
.goback{
  width: 20px;
  height: 20px;
  margin-top: 14px;
  opacity: 0.5;
}
.search-bar {
  padding: 0 5px;
}
.top {
  position: fixed;
  width: 100%;
  z-index: 11;
  ul {
    width: 100%;
    background: #4fae54;
    font-size: 14px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    li {
      color: #ffffffb3;
      text-align: center;
      &.cur {
        color: #ffffff;
        position: relative;
        i {
          border-bottom: 2px solid #fff;
          display: block;
          width: 28px;
          height: 1px;
          position: absolute;
          bottom: -5px;
          left: 50%;
          margin-left: -14px;
        }
      }
    }
  }
}
.buyBlock {
  .buyBlockTop {
    background: none;
  }
}
.back {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  height: 44px;
  width: 0.8rem;
  z-index: 100;
  display: flex;
  align-items: center;
  img {
    height: 0.35rem;
    margin-right: 5px;
    vertical-align: top;
    margin-left: 10px;
  }
}
.scan{
  height: 45px;
  line-height: 38px;
  padding-right: 15px;
  img{
    height: 24px;
  }
}
.customerInfo {
  font-size: 0.24rem;
  display: flex;
  justify-content: space-between;
  background: #4fae54;
  padding: 2px 10px;
  color: #fff;
}
.customerName {
  font-size: 0.24rem;
  padding-left: 1em;
  display: flex;
  color: #666666;
}
.carInfo {
  margin: 0 5px;
  background: #fff;
  .carImg {
    float: left;
    padding: 20px 15px 0 20px;
    height: 95px;
    img {
      width: 1.82rem;
      height: 1.07rem;
    }
  }
}
.groupList {
  background: rgba(246, 246, 246, 1);
}
.jiucuo {
  position: absolute;
  right: 10px;
  bottom: 43%;
  z-index: 10;
}
.float-box {
  position: absolute;
  //top:-2rem;
  bottom: 55px;
  left: 40px;
  font-size: 0.32rem;
  background: #fff;
  padding: 0.1rem;
  border-radius: 0.1rem;
  width: 2rem;
  text-align: center;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  li {
    padding: 0.1rem;
    border-bottom: 1px solid #ddd;
  }
  li:last-child {
    border-bottom: none;
  }
}
.float-box::after {
  position: absolute;
  bottom: -9px;
  left: 23px;
  content: "";
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
}

/* iphone11 兼容 */
@supports (bottom: env(safe-area-inset-bottom)) {
  .float-box {
    bottom: calc(env(safe-area-inset-bottom) + 55px) !important;
  }
}
.opera {
  position: relative;
  height: 0.5rem;
  display: block;
  background: transparent;
  z-index: 1;
  .opera-box {
    position: absolute;
    right: 0;
  }
}
.list {
  background: #fff;
  li {
    border-radius: 0;
    border-bottom: 1px solid #f5f5f5;
    padding: 0 0 0.1rem 0;
  }
  &.list2 {
    padding: 0;
  }
}

.h110 {
  height: 110px;
}
.h125 {
  height: 125px;
}
.h155 {
  height: 155px;
}
.h160 {
  height: 160px;
}
.h170 {
  height: 170px;
}
.h175 {
  height: 175px;
}
</style>

<style lang="scss">
html {
  background: #f6f6f6;
}
.indexPage {
  .van-tabs__line {
    bottom: 20px;
  }
  .van-info {
    background: #4fae54;
  }
}
.carInfo {
  border-radius: 5px;
  .van-sticky--fixed {
    width: calc(100% - 10px);
    margin: 0 5px;
    background: #fff;
  }
  .van-sticky {
    padding: 10px 0;
  }
}
.bounceIn {
  -webkit-animation: bounceIn 4s infinite;
  -moz-animation: bounceIn 0.5s infinite;
  -o-animation: bounceIn 0.5s infinite;
  animation: bounceIn 0.5s infinite;
}
.select-warehouse {
  max-width: 120px;
  margin-right: 12px;
  .van-dropdown-menu__title {
    font-size: 14px;
  }
  .van-dropdown-menu__bar {
    box-shadow: none;
  }
}
@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
